<template>
    <div class="pushList">
		<leftnav class="fl" mkcode="C" :itemcode="yj_itemcode"></leftnav>
		<div class="index_left" :style="isCollapse ? 'margin-left: 0;width:100%' : ''">
			<govheader></govheader>
			<div class="index_left_centerpage">
                <div class="whitebox right_topbox">
				</div>
				<div class="whitebox">
					<div class="py-3">
                        <el-button v-show="pushData.pushStatus==1" type="primary" size="medium" class="fr mr-45 mb-3" @click="pushFun">已推送单位：{{pushData.pushCompanyName}}</el-button>
                        <el-button v-show="pushData.pushStatus != 1" type="primary" size="medium" class="fr mr-45 mb-3" @click="pushFun">开始推送</el-button>
                        <table border="0" cellspacing="0" cellpadding="0" class="push_table">
                            <tr>
                                <th rowspan="6" style="width: 274px;">项目基本信息</th>
                            </tr>
                            <tr>
                                <td>项目名称</td>
                                <td>{{pushData.land.projectName}}</td>
                            </tr>
                            <tr>
                                <td>行业分类</td>
                                <td>{{pushData.land.industry}}</td>
                            </tr>
                            <tr>
                                <td>所在区域</td>
                                <td v-show="userdata.zsdn_version == 1">{{pushData.land.area}}</td>
                                <td v-show="userdata.zsdn_version == 2">{{pushData.land.investArea}}</td>
                            </tr>
                            
                            <tr v-show="userdata.zsdn_version == 1">
                                <td>土地用途</td>
                                <td>{{pushData.land.purpose}}</td>
                            </tr>
                        </table> 
                        <!-- 相关企业匹配结果 -->
                        <table border="0" cellspacing="0" cellpadding="0" class="push_table">
							<tr>
								<th rowspan="2">序号</th>
                                <th rowspan="2">公司名称</th>
                                <th rowspan="2">总分</th>
								<th rowspan="2">点对点</th>
                                <th colspan="4">城对城</th>
								<th colspan="3">业对业</th>
                                <!-- <th rowspan="2">推送对象</th> -->
							</tr>
                            <tr>
                                <th>百城主责城市</th>
                                <th>主责区域</th>
                                <th>重点区域</th>
                                <th>培育区域</th>
                                <th>拳头产品</th>
                                <th>主营产品</th>
                                <th>辅助产品</th>
                            </tr>
                            <tr v-for="(item,index) in enterpristlist" :key="item.stockcode">
                                <td>{{(page-1)*pageSize+index+1}}</td>
                                <td>{{item.companyName}}</td>
                                <td :class="item.total>0?'curTd':''">{{item.total || '-'}}</td>
                                <td :class="item.p2p>0?'curTd':''">{{item.p2p || '-'}}</td>
                                <td :class="item.city1>0?'curTd':''">{{item.city1 || '-'}}</td>
                                <td :class="item.city2>0?'curTd':''">{{item.city2 || '-'}}</td>
                                <td :class="item.city3>0?'curTd':''">{{item.city3 || '-'}}</td>
                                <td :class="item.city4>0?'curTd':''">{{item.city4 || '-'}}</td>
                                <td :class="item.industry1>0?'curTd':''">{{item.industry1 || '-'}}</td>
                                <td :class="item.industry2>0?'curTd':''">{{item.industry2 || '-'}}</td>
                                <td :class="item.industry3>0?'curTd':''">{{item.industry3 || '-'}}</td>
                                <!-- <td class="collectfont1" @click="pushFun(item)"><span>推送 ></span> </td> -->
                            </tr>
                        </table>
                        <el-dialog class="pushDialog" :modal-append-to-body="false" append-to-body title="" :visible.sync="isShowPush" width="1000px" top="15vh">
                            <el-dialog class="pushDialog" :modal-append-to-body="false" append-to-body title="" :visible.sync="isShowPushCompany" width="1000px" top="25vh">
                            <dl class="opport-screen bdbe">
                                <dt class="fl">推送单位</dt>
                                <dd class="fl "> 
                                    <span :key="index" v-for="(item,index) in companylist" @click="temCompany.id = item.id;temCompany.name = item.title; "
                                        :class="temCompany.id == item.id ?'a-screen current' : 'a-screen'"
                                        >{{item.title}} </span>
                                </dd>
                            </dl>
                            <div class="mr-1 mb-3 pt-3">
                                <el-button size="small" type="success " class="fr" @click="isShowPushCompany = false;pushPramas.companyId = temCompany.id;pushData.matchCompanyName = temCompany.name">确认修改</el-button>
                            </div>
                             
                            </el-dialog>
                            <div><el-button :loading="pushBtnLoading" type="primary" size="small" class="fr mr-3 mb-3" @click="postPush">确认推送</el-button></div>
                            <table border="0" cellspacing="0" cellpadding="0" class="land_table"> 
                                <tr>
                                    <th rowspan="4" width="120px">接收单位</th>
                                    <!-- <td colspan="3">{{pushData.company}}</td> -->
                                     <!-- <td>单位名称</td> -->
                                    <td colspan="3">
                                       <span v-show="!isShowPushCompany"> {{pushData.matchCompanyName}} </span>
                                        <!-- <el-select v-show="isShowPushCompany" class="seletc-size-input" v-model="pushPramas.companyId" placeholder="请选择" @change="companyChage">
                                            <el-option v-for="(item, index) in companylist" :key="index" :value="item.id" :label="item.title"></el-option>
                                        </el-select>  -->
                                        <el-button size="small" type="success " class="fr mr-1" @click="isShowPushCompany = true;pushPramas.temCompanyId = pushPramas.companyId">修改</el-button>
                                    </td>
                                </tr>
                                <!-- <tr>
                                    <td>业务范围</td>
                                    <td colspan="3">{{pushData.scope}}</td>
                                </tr>
                                <tr>
                                    <td>所在省份</td>
                                    <td>{{pushData.province}}</td>
                                    <td>所在城市</td>
                                    <td>{{pushData.city}}</td>
                                </tr> -->
                            </table>
                             <table border="0" cellspacing="0" cellpadding="0" class="land_table mt-3" v-if="userdata.zsdn_version == 1"> 
                                <tr>
                                    <th rowspan="6" width="120px">项目基本信息</th>
                                     <td>项目名称</td>
                                    <td colspan="3">{{pushData.land.projectName}}</td>
                                </tr>
                                <tr>
                                    <td>行业分类</td>
                                    <td colspan="3">{{pushData.land.industry}}</td>
                                </tr>
                                <tr>
                                    <td>所在省份</td>
                                    <td>{{turnText('province')}}</td>
                                    <td>所在城市</td>
                                    <td>{{turnText('city')}}</td>
                                </tr>
                                <tr>
                                    <td>土地使用权人</td>
                                    <td>{{pushData.land.owner}}</td>
                                    <td>投资主体</td>
                                    <td>{{pushData.land.sourceEnterprise}}</td>
                                </tr>
                                <tr>
                                    <td>面积（亩）</td>
                                    <td>{{pushData.land.size.toFixed(2)}}</td>
                                    <td>容积率</td>
                                    <td>{{pushData.land.volumeLower}} / {{pushData.land.volumeUpper}}</td>
                                </tr>
                                <tr>
                                    <td>土地用途</td>
                                    <td>{{pushData.land.purpose}}</td>
                                    <td>土地使用年限</td>
                                    <td>{{pushData.land.useYears}}</td>
                                </tr>
                            </table>
                            <table border="0" cellspacing="0" cellpadding="0" class="land_table mt-3" v-if="userdata.zsdn_version == 2"> 
                                <tr>
                                    <th rowspan="6" width="120px">项目基本信息</th>
                                     <td>项目名称</td>
                                    <td colspan="3">{{pushData.land.projectName}}</td>
                                </tr>
                                <tr>
                                    <td>行业分类</td>
                                    <td colspan="3">{{pushData.land.industry}}</td>
                                </tr>
                                <tr>
                                    <td>投资地点</td>
                                    <td colspan="3">{{pushData.land.investArea}}</td>
                                </tr>
                                <tr>
                                    <td>投资金额</td>
                                    <td colspan="3">{{pushData.land.money}}{{  pushData.land.moneyUnit }}</td>
                                </tr>
                                <tr>
                                    <td>公司简称</td>
                                    <td colspan="3">{{pushData.land.shortName}}</td>
                                </tr>
                                <tr>
                                    <td>公司全称</td>
                                    <td colspan="3">{{pushData.land.companyName}}</td>
                                </tr>
                            </table>
                        </el-dialog>
					</div>
					<div class="centerpage1 company_pagelist" v-show="totalPage > 1">
						<zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"
							v-bind:max-page="maxPage" v-on:pagehandler="pageHandler"></zpagenav>
					</div>
				</div>

			</div>
		</div>
	</div>
</template>
<script> 
import { mapState, mapMutations, mapGetters } from "vuex";
export default {
    name: 'clueManagement',
    computed: {
		...mapState({
			// isCollapse: (state) => state.app.isCollapse,
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
    data() {
        return {
            userdata: {},
            page: 1,
            haspage: true,
            pageSize: 10,
            total: 0,
            totalPage: 1,
            maxPage: 10,
            yj_itemcode: "A01",
            enterpristlist: [],
            isShowPush: false,
            pushData: {
                land: {projectName: null,area: null},
                matchCompanyName: null,
                pushStatus: null,

            },
            id: null,
            companylist: [],
            isShowPushCompany: false,
            pushPramas: {
                companyId: null,
                // companyName: null,
                id: null,
            },
            temCompany:{id: null,name: null},
            pushBtnLoading: false,
        };
    },
    created() { 
        this.userdata = this.getuseriformation();
        this.id = this.$route.query.id;
    },
    mounted() {
        this.ajaxsearchcompany();
        this.getPushCompanyList();
        this.pushPramas.id = this.id;
    },
    methods: {
        companyChage(val) {
            console.log('companyChage', val,this.pushPramas.companyId);
        },
        //确认推送
        postPush() { 
            this.pushBtnLoading = true;
            var ajaxurl = '';
            if(this.userdata.zsdn_version == 1){
               ajaxurl = this.$api.metall.LandPush.Push();  
            }else{
                ajaxurl = this.$api.metall.InvestPush.Push();
            }
            console.log('this.pushPramas',this.pushPramas);
            // return  
            $.ajax({
                type: "POST",
                url: ajaxurl,
                data: this.pushPramas,
                headers: { AuthToken: this.userdata.token },
                // dataType: "json",
                success: (res) => {
                    if (res.success) {
                        this.isShowPush = false;
                        this.pushData.pushStatus = '2';
                        this.pushBtnLoading = false;
                        this.$message.success("推送成功");
                    }else{
                        this.pushBtnLoading = false;
                        this.$message.error(res.msg);
                    }
                },
                error: (res) => {
                    this.pushBtnLoading = false;
                    this.$message.error("推送失败");
                }
            })
            // this.$axios.post(this.$api.metall.LandPush.Push(), this.pushPramas, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then((res) => {
            //     if (res.data.success) {
            //         this.isShowPush = false;
            //         this.pushData.pushStatus = '2';
            //         this.pushBtnLoading = false;
            //         this.$message.success("推送成功");
            //     } else {
            //         this.pushBtnLoading = false;
            //         this.$message.error(res.data.msg);
            //     }
            // })
        },
        turnText(type) {
            //pushData.land.area提取省份和城市
            if(this.pushData.land) {
                // 正则匹配：省、市、县/区
                const pattern = /^(.*?省)(.*?[市|地区|自治州])(.*?[县|区|市]?)$/;
                const match = this.pushData.land.area.match(pattern);

                if (match) {
                const province = match[1]; // 第一个捕获组：省份
                const city = match[2];     // 第二个捕获组：城市
                // const district = match[3]; // 第三个捕获组：县级（如果需要）

                // console.log("省份:", province); // 输出: 河南省
                // console.log("城市:", city);     // 输出: 洛阳市
                return type === 'province' ? province : city
                }
                
            }
        },
        //获取推送公司列表
        getPushCompanyList() { 
            this.bus.$emit('loading', true);
            this.$axios.get(this.$api.metall.Company.list()).then((res) => {
               if (res.data.success) { 
                console.log('公司列表',res);
                this.companylist = res.data.list;
                this.bus.$emit('loading', false);
               }
            })
        },
        pushFun() {
            console.log('推送', this.pushData);
            this.isShowPush = true;

        },
        ajaxsearchcompany(page) {
            console.log('ajaxsearchcompany', page);
            this.bus.$emit('loading', true);
            var ajaxurl = '';
            if(this.userdata.zsdn_version == 1){
               ajaxurl = this.$api.metall.LandThread.Match();  
            }else{
                ajaxurl = this.$api.metall.investThread.Match();
            }
            this.$axios.get(ajaxurl+'?id='+this.id).then((res) => {
               if (res.data.success) { 
                console.log('res.data。pushdasta',res);
                this.pushData = res.data.data;
                this.pushPramas.companyId = this.pushData.matchCompanyId;
                this.temCompany.name = this.pushData.matchCompanyName;
                this.enterpristlist = res.data.data.list;
                this.bus.$emit('loading', false);
               } else {
                //    this.$message.error(res.data.message); 
                this.bus.$emit('loading', false);
               }
           })
        },
        delClue(item) {
            console.log('移除线索管理', item);
        },
        pageHandler(page) {
            this.page = page;
            // this.ajaxsearchcompany(page);
        },
    },
};
</script>
<style lang="scss">
.mr-45{
    margin-right: 45px !important;
}
.pushDialog {
.land_table tr td{
    border-bottom: 1px solid #dcdcdc;
    min-width: 136px;
    font-size: 16px;
    padding: 10px 0;
}
}
.push_table{
    width: 95%;
    margin: 0 auto;
    border-top: 1px solid #f2f2f2;
    border-left: 1px solid #f2f2f2; 
    th,td{
        border-bottom: 1px solid #dcdcdc;
        border-right: 1px solid #dcdcdc;
        border-collapse: collapse;
        text-align: center;
        font-size: 16px;
        padding: 8px;
    }
    th{
        background: #f2f8fe;

    }
    .curTd{
        background: #d1e9ff;

    }
    td{
        // background: #f5f5f5;
    }

}
</style>